const StudentProgressReportPypElementRatingTypePolicy = {
  StudentProgressReportPypElementRating: {
    keyFields: object => {
      if (object.contextId != null && object.contextType != null) {
        return `StudentProgressReportPypElementRating:${object.id}:${object.contextId}:${object.contextType}`;
      }
      return `StudentProgressReportPypElementRating:${object.id}`;
    },
  },
};

export default StudentProgressReportPypElementRatingTypePolicy;
